module.exports = __webpack_public_path__ + "static/media/mailchimp.aca93404.svg";